<div mat-dialog-content>
    <p>{{labels.lblWrongLoginData}}</p>
  </div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{labels.lblOk}}</button>
</div>
